import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={36}
      height={24}
      viewBox="0 0 36 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={0.5} y={0.5} width={35} height={23} fill="white" />
      <rect x={0.5} y={0.5} width={35} height={23} stroke="#E2E8F0" />
      <path
        d="M16.0837 14.2504C16.0117 14.2876 15.9307 14.3091 15.8446 14.3091C15.6453 14.3091 15.472 14.1969 15.3811 14.0307L15.3462 13.9527L13.895 10.6929C13.8793 10.6575 13.8696 10.6174 13.8696 10.5784C13.8696 10.4281 13.9886 10.3064 14.1354 10.3064C14.1949 10.3064 14.2501 10.3266 14.2944 10.3603L16.0069 11.6085C16.132 11.6922 16.2815 11.7413 16.4422 11.7413C16.5381 11.7413 16.6296 11.7231 16.7148 11.6913L24.7683 8.02226C23.3247 6.28078 20.9473 5.14258 18.2569 5.14258C13.8543 5.14258 10.2856 8.18687 10.2856 11.9425C10.2856 13.9912 11.3593 15.8355 13.04 17.0822C13.1747 17.1807 13.263 17.3426 13.263 17.5253C13.263 17.5857 13.2504 17.6408 13.2349 17.6984C13.1007 18.2109 12.8859 19.0317 12.8759 19.0702C12.8591 19.1345 12.833 19.2017 12.833 19.269C12.833 19.4192 12.9519 19.5409 13.0989 19.5409C13.1565 19.5409 13.2036 19.5189 13.2523 19.4903L14.9974 18.4589C15.1287 18.3815 15.2676 18.3333 15.4208 18.3333C15.5022 18.3333 15.5809 18.3463 15.655 18.3695C16.4691 18.6092 17.3475 18.7423 18.257 18.7423C22.6593 18.7423 26.2285 15.6979 26.2285 11.9425C26.2285 10.8049 25.8992 9.73367 25.3204 8.79129L16.1421 14.2159L16.0837 14.2504Z"
        fill="#1AAD19"
      />
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-wechat-pay" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
